import { County } from "../..";

export enum CoverageSelectorCoverageType {
  MAPD = "MEDICARE_ADVANTAGE_PLAN",
  PDP = "PRESCRIPTION_DRUG_PLAN",
  PDPAndMedigap = "MEDICARE_ADVANTAGE_PLAN_AND_MEDIGAP",
  MedigapPolicy = "MEDIGAP_POLICY",
  learnMore = "LEARN_MORE",
}

export enum CoverageSelectorErrorType {
  NONE,
  INVALID,
  MISSING,
  API,
}

export interface CoverageSelectorInitialValues {
  coverageYear?: number;
  zipcode?: string;
  fips?: string;
  coverageType?: CoverageSelectorCoverageType;
}

export interface CoverageSelectorFormValues {
  coverageYear?: number;
  zipcode?: string;
  county?: County;
  coverageType?: CoverageSelectorCoverageType;
}

export type CoverageSelectorSelectedValues =
  Required<CoverageSelectorFormValues>;

export interface CoverageSelectorErrorState {
  error: CoverageSelectorErrorType | null;
  message: string | undefined;
}
